import { Component, OnInit } from "@angular/core";
import { Data, Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { Breadcrumb } from "../model/breadcrumb.model";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false // NOSONAR
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: Breadcrumb[];
  private readonly aetTabBreadcrumbMap: Record<string, string> = {
    dashboard: 'Dashboard',
    cpMatrix: 'Control Point Matrix',
    'safety-dashboard': 'AET Safety Dashboard',
    import: 'AET Import',
    'reports-dashboard': 'AET Reports',
    kpi: 'AET KPI',
    notifications: 'AET Notifications',
    history: 'History'
  };

  constructor(private readonly router: Router, private readonly activatedRoute: ActivatedRoute) {
    this.breadcrumbs = this._buildBreadcrumbs(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this._buildBreadcrumbs(this.activatedRoute.root);
      });
  }

  private _buildBreadcrumbs(
    activatedRoute: ActivatedRoute,
    url: string = ""
  ): Breadcrumb[] {
    const customAetBreadcrumbs = this._buildAetTabBreadcrumbs();
    if (customAetBreadcrumbs) {
      return customAetBreadcrumbs;
    }

    const children: ActivatedRoute[] = activatedRoute.children;

    if (children.length == 0) {  // NOSONAR
      return [];
    }

    let breadcrumbs: Breadcrumb[] = [];

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");
      if (routeURL != "") { // NOSONAR
        url += `/${routeURL}`;
      }

      const routeData: Data = child.snapshot.data;
      if (routeData["breadcrumb"]) {
        breadcrumbs.push({ label: routeData["breadcrumb"], url: url });
      } else if (routeData["apiData"] && routeData["apiData"].breadcrumb) {
        breadcrumbs.push({
          label: routeData["apiData"].breadcrumb,
          url: url
        });
      }
      else if (routeURL != "") { // NOSONAR
        breadcrumbs.push({
          label: routeURL,
          url: url
        });
      }

      breadcrumbs = breadcrumbs.concat(this._buildBreadcrumbs(child, url));
    }

    return breadcrumbs;
  }

  private _buildAetTabBreadcrumbs(): Breadcrumb[] | null {
    const cleanUrl = this.router.url.split('?')[0].split('#')[0];
    const [rootPath] = cleanUrl.split('/').filter(Boolean);

    if (!rootPath) {
      return null;
    }

    const tabLabel = this.aetTabBreadcrumbMap[rootPath];
    if (!tabLabel) {
      return null;
    }

    const tabUrl = `/${rootPath}`;
    return [
      { label: 'Operations', url: tabUrl },
      { label: 'AET', url: tabUrl },
      { label: tabLabel, url: tabUrl }
    ];
  }
}
